<template>
  <nav :class="navclass">
    <ul class="nav nav--subnavigation">
      <li
        v-for="(item, index) in visibleItems"
        :key="index"
        class="nav--subnavigation__item"
      >
        <a
          class="nav--subnavigation__link ga-category-link"
          :href="item.link"
        >{{ item.title }}</a>
      </li>
    </ul>
    <button
      v-if="items.length > 6 && !showAllItems"
      class="subnavigation-button show-more-button"
      @click.prevent="toggle()"
    >
      {{ $modeoL10n.show_all }}
    </button>
  </nav>
</template>

<script>
    export default {
        props: {
            items: {
                type: Array,
                default: function () {
                    return [];
                },
            },
            navclass: {
                type: String,
                default: '',
            },
            full: Boolean,
        },
        data : function () {
            return {
                mobile: window.innerWidth < 640,
                itemsExpanded: false,
            };
        },
        computed: {
            visibleItems: function() {
                return this.showAllItems || this.items.length <= 6 ? this.items : this.items.slice(0,5)
            },
            showAllItems: function() {
                return this.full || !this.mobile || this.itemsExpanded
            },
        },
        created : function() {
            addEventListener('resize', () => {
                this.mobile = innerWidth < 640
            });
        },
        methods: {
            toggle : function() {
                this.itemsExpanded = !this.itemsExpanded;
            },
        },
    }
</script>
